(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["review-feed"] && !Shopify.designMode) return;
  try {
    
  function toggleReadMore(id, btn) {
    const el = document.getElementById(id);
    if (!el) return;
    el.classList.toggle('expanded');
    btn.textContent = el.classList.contains('expanded') ? 'Lees minder' : 'Lees meer';
  }

  document.addEventListener('DOMContentLoaded', function () {
    const pages = document.querySelectorAll('.review-pages');
    const prevBtn = document.getElementById('prevPageBtn');
    const nextBtn = document.getElementById('nextPageBtn');
    const TOTAL_PAGES = pages.length;
    let currentPage = 1;

    function updateArrows() {
      if (prevBtn) prevBtn.disabled = (currentPage === 1);
      if (nextBtn) nextBtn.disabled = (currentPage === TOTAL_PAGES);
    }

    function showReviewPage(page) {
      if (!TOTAL_PAGES) return;
      currentPage = page;
      pages.forEach(p => p.classList.remove('active'));
      const active = document.querySelector('.page-' + currentPage);
      if (active) active.classList.add('active');
      updateArrows();
    }

    if (prevBtn) prevBtn.addEventListener('click', () => { if (currentPage > 1) showReviewPage(currentPage - 1); });
    if (nextBtn) nextBtn.addEventListener('click', () => { if (currentPage < TOTAL_PAGES) showReviewPage(currentPage + 1); });

    // verberg lees-meer knoppen waar geen extra tekst is
    document.querySelectorAll('.review-body').forEach(function (el) {
      const more = el.querySelector('.more');
      const btn = el.querySelector('.read-more-btn');
      const dots = el.querySelector('.dots');
      if (!more || !more.textContent.trim()) {
        if (btn) btn.style.display = 'none';
        if (dots) dots.style.display = 'none';
      }
    });

    showReviewPage(1);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specifications"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.specs-content details').forEach((detail) => {
    detail.addEventListener('toggle', () => {
      if (detail.open) {
        document.querySelectorAll('.specs-content details').forEach((other) => {
          if (other !== detail) other.removeAttribute('open');
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
